import { createFileRoute } from "@tanstack/react-router";
import LandingPage from "@/pages/LandingPage";
import { landingPages } from "@/data/landingPages";
import { landingSchemas, pageHead } from "@/lib/seo";

const c = landingPages["fractional-cmo-b2c-ecommerce"]!.en!;

export const Route = createFileRoute("/en/fractional-cmo-b2c-ecommerce")({
  head: () =>
    pageHead({
      path: "/en/fractional-cmo-b2c-ecommerce",
      title: c.title,
      description: c.description,
      crumbs: [["Fractional CMO B2C & E-commerce", "/en/fractional-cmo-b2c-ecommerce"]],
      schemas: landingSchemas(c),
    }),
  component: () => <LandingPage pageKey="fractional-cmo-b2c-ecommerce" forceLanguage="en" pathOverride="/en/fractional-cmo-b2c-ecommerce" />,
});
